<template>
  <b-overlay :show="busy" spinner-type="grow" spinner-variant="primary" rounded="sm">
    <b-card class="border-none py-0 mb-0 no-margin px-1 componentview">
      <b-card-body class="py-0">
        <b-tabs class="gridtabs">
          <b-tab active>
            <template #title>
              <!-- <i class="fa fa-cog text-primary mr-1"></i>
              General -->
              <div class="badgecontainer pr-2 mr-1">
                <i class="fa fa-cog text-primary mr-1"></i>
                General
                <b-badge id="selection" variant="primary" class="edit_tab">
                  {{ selection.length }}</b-badge>
                <b-tooltip target="selection" placement="bottom">{{ selection.length }} invoice(s)
                  selected</b-tooltip>
              </div>
            </template>
            <p class="py-3 px-0">
              <b-row>
                <b-col cols="12" md="5">
                  <b-form-group label="Email To" label-for="email" label-cols="12">
                    <b-input-group>
                      <b-form-input type="text" v-model="email" placeholder="Email" size="sm"></b-form-input>
                      <b-input-group-append>
                        <b-button size="sm" variant="outline-secondary" @click="email = ''">
                          <i class="fa fa-remove"></i>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col cols="12" md="5" class="mt-4">
                  <b-form-checkbox id="copy" v-model="copy" name="copy" value="true" unchecked-value="false">
                    Send me a copy (
                    <span class="text-primary">{{ user.email }}</span> )
                  </b-form-checkbox>
                </b-col>
              </b-row>
              <b-row class="mt-4">
                <b-col cols="12">
                  <b-form-checkbox id="emailzipped" v-model="emailzipped" name="emailzipped" value="1"
                    unchecked-value="0">
                    Attachments as zip
                  </b-form-checkbox>
                </b-col>
              </b-row>
              <b-row class="mt-3">
                <b-col cols="12">
                  <b-form-checkbox id="groupbyslac" v-model="groupbyslac" name="groupbyslac" value="1"
                    unchecked-value="0">
                    Group by SL A/C
                  </b-form-checkbox>
                </b-col></b-row>
            </p>
          </b-tab>
          <b-tab>
            <template #title>
              <i class="fa fa-envelope text-primary mr-1"></i>
              Email Template</template>
            <p class="py-3 px-0">
              <b-row>
                <b-col cols="12" md="5">
                  <b-form-group label="From" label-for="from" label-cols="12">
                    <b-input-group>
                      <b-form-input type="text" v-model="emailfrom" disabled placeholder="From" size="sm"></b-form-input>
                      <b-input-group-append>
                        <b-button size="sm" variant="outline-secondary" @click="emailfrom = ''" disabled>
                          <i class="fa fa-remove"></i>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col cols="12" md="10">
                  <b-form-group label="Subject" label-for="subject" label-cols="12">
                    <b-input-group>
                      <b-form-input type="text" v-model="subject" disabled placeholder="Subject" size="sm"></b-form-input>
                      <b-input-group-append>
                        <b-button size="sm" variant="outline-secondary" @click="subject = ''">
                          <i class="fa fa-remove"></i>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" md="10">
                  <b-form-group label="Message" label-for="message" label-cols="12">
                    <wysiwyg v-model="body" placeholder="Message..." />
                  </b-form-group>
                </b-col>
              </b-row>
              <!--
              <b-row>
                <b-col cols="10" md="10" class="text-right mt-1"> </b-col
              ></b-row> -->
            </p>
          </b-tab>
        </b-tabs>

        <div>
          <b-row>
            <!-- <b-col cols="12" md="2">
              <b-form-checkbox
                id="emailzipped"
                v-model="emailzipped"
                name="emailzipped"
                value="1"
                unchecked-value="0"
              >
                Attachments as zip
              </b-form-checkbox>
            </b-col> -->
            <!-- <b-col cols="12" md="5">
              <b-form-checkbox
                id="copy"
                v-model="copy"
                name="copy"
                value="true"
                unchecked-value="false"
              >
                Send me a copy (
                <span class="text-primary">{{ user.email }}</span> )
              </b-form-checkbox>
            </b-col> -->
            <!-- <b-col cols="12" md="3" class="text-right">
              <b-button-group>
                <b-button squared size="sm" @click="send()" variant="primary">
                  <i class="fa fa-paper-plane pr-3"></i>Send
                </b-button>
              </b-button-group>
            </b-col> -->
          </b-row>
        </div>
      </b-card-body>
      <b-card-footer class="mt-2 ml-1">
        <b-row>
          <b-col class="text-left">
            <div v-if="busy">
              <i class="fa fa-spinner fa-spin text-primary"></i>
            </div>
            <div v-else>
              <span v-html="message"></span>
            </div>
          </b-col>
          <b-col class="text-right" cols="8">
            <b-button-group>
              <b-button squared size="sm" class="mr-1" @click="send()" variant="primary">
                <i class="fa fa-paper-plane pr-3"></i>Send
              </b-button>
            </b-button-group>
            <b-button squared size="sm" variant="secondary" @click="discard">
              <i class="fa fa-chevron-left pr-1"></i>
              Back
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer>
    </b-card>
  </b-overlay>
</template>

<script>
import gql from "graphql-tag";

export default {
  name: "SLItemEmail",
  data() {
    return {
      busy: false,
      message: "",
      isgroup: false,
      email: null,
      emailfrom: null,
      subject: null,
      message: null,
      body: null,
      copy: true,
      emailzipped: "1",
      groupbyslac: "1",
    };
  },
  async mounted() {
    this.email = this.user.email;
    this.emailfrom = await this.getsystemsetting("email_invoice_from");
    this.body = await this.getsystemsetting("email_invoice");
    if (this.selection.length > 1) {
      this.subject = "Invoice from Travel Places Ltd for <each client>";
    } else {
      this.subject =
        "Invoice from Travel Places Ltd for " + this.selection[0].to;
    }
  },
  methods: {
    async send() {
      this.busy = true;

      let variables = {
        selected: this.cleanit(this.selection),
        documentformat: "INV_1",
        emailto: this.email,
        emailzipped: this.emailzipped == "1" ? true : false,
        groupbyslac: this.groupbyslac == "1" ? true : false,
        isgroup: this.selection.length > 1 ? true : false,
      };

      variables.selected.forEach(function (v) {
        delete v.lines;
      });
      console.log("variables", variables);

      let sent = false;
      try {
        const response = await this.$apollo.query({
          query: gql`
            query SLTransactions(
              $selected: [SLTransaction_input]
              $documentformat: String
              $emailto: String
              $isgroup: Boolean
              $emailzipped: Boolean
              $groupbyslac: Boolean
            ) {
              SLTransactions(
                selected: $selected
                documentformat: $documentformat
                emailto: $emailto
                isgroup: $isgroup
                emailzipped: $emailzipped
                groupbyslac: $groupbyslac
              ) {
                id
              }
            }
          `,
          variables,
        });

        this.items = response.data.SLTransactions;
        sent = response.data.SLTransactions.length > 0 ? true : false;
      } catch (error) {
        console.log(error);
      }

      if (sent) {
        this.message = "<span class='text-primary'>Emailed it.</span>";
      } else {
        this.message = "<span class='text-danger'>Email not sent!</span>";
      }
      this.busy = false;
    },
  },
};
</script>

<style></style>